/* unplugin-vue-components disabled */import script from "./MultiTab.vue?vue&type=script&setup=true&lang=js"
export * from "./MultiTab.vue?vue&type=script&setup=true&lang=js"

import "./MultiTab.vue?vue&type=style&index=0&id=56c7e114&scoped=true&lang=css"

import exportComponent from "D:\\星网代码\\2018-05-18 路特利\\2022-02-23需求\\DM.LtlApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-56c7e114"]])

export default __exports__